import React from "react";
import "./Testimonials.css";
const Testimonials = ({ image, text, name }) => {
  return (
    <div className="t-t-main ">
      <div
        className="t-img-main cursor-pointer hover:scale-105 
    transform transition duration-300 ease-out"
      >
        <img className="t-img" src={image} alt="some-img" />
        <div className="t-text">
          <h2 className="t-h2">{name}</h2>
          <h1 className="t-h1">{text}</h1>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
